import ministryService from "../../services";
export default {
  namespaced: true,
  state: () => {
    return {
      ngos: [],
      loading: false,
      searchTags: JSON.parse(sessionStorage.getItem("searchTags")) || [],
    };
  },
  getters: {
    ngos(state) {
      return state.ngos;
    },

    loading(state) {
      return state.loading;
    },
    searchTags(state) {
      var x = state.searchTags.reverse().slice(0, 6);
      return x;
    },
  },
  mutations: {
    setData(state, payload) {
      state.ngos = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
    pushSearchTag(state, payload) {
      if (state.searchTags.includes(payload)) {
        state.searchTags.splice(state.searchTags.indexOf(payload), 1);
      }
      state.searchTags.push(payload);
      sessionStorage.setItem("searchTags", JSON.stringify(state.searchTags));
    },
  },
  actions: {
    async fetchSearchResults({ commit, state }, key) {
      commit("setLoading", true);
      try {
        const data = await ministryService.fetchNgosSearchResults(key);
        commit("setData", data.data);
        commit("pushSearchTag", key);
      } catch (err) {
      } finally {
        commit("setLoading", false);
      }
    },
  },
};
